module.exports = __webpack_public_path__ + "static/media/main idea.140b3805.mp3";